import { type QueryClient } from '@tanstack/react-query'

import { useAuthStore } from '#firebase/authStore'

/**
 * Drops every cached document when the signed-in account changes. Mobile keeps
 * one process, and one QueryClient, across a sign-out, so cached data outlives
 * the account that fetched it (ZL-985).
 *
 * Subscribing to the uid rather than to the User object matters: the auth
 * listener re-runs setUser on every token refresh.
 */
export const clearQueryCacheOnUserChange = (
  client: QueryClient
): (() => void) =>
  useAuthStore.subscribe(
    state => state.user?.uid ?? null,
    (_uid, previousUid) => {
      if (previousUid === null) return

      client.clear()
    }
  )
